import { connect } from 'react-redux';
import { getBase, getSearchType, getEmployerId, getIsMobile } from '../../../modules/Settings';
import { getFacetGroups, getRole, getFacets, getKeywords, toggleShowMoreVisible, getShowMoreVisible, getSelectedMoreFilter, setSelectedMoreFilter,
  getLocationBreadcrumb, getSelectedFacets, setLocationBreadcrumb, clearFilters, getMetadata } from '../../../modules/Filters';
import { getDoubleMpu, getLoading } from '../../../modules/JobsList';
import { updateUrl, removeUrlPart, clearAllFromUrl, clearTagFromUrl } from '../../../app/helpers';
import TopFilters from './TopFilters';

const mapStateToProps = state => ({
  facetGroups: getFacetGroups(state),
  facets: getFacets(state),
  doubleMpu: getDoubleMpu(state),
  pathname: getBase(state).pathname,
  keywords: getKeywords(state),
  base: getBase(state),
  role: getRole(state),
  selectedFacets: getSelectedFacets(state),
  showMoreVisible: getShowMoreVisible(state),
  selectedMoreFilter: getSelectedMoreFilter(state),
  searchType: getSearchType(state),
  employerId: getEmployerId(state),
  locationBreadcrumb: getLocationBreadcrumb(state),
  metadata: getMetadata(state),
  loading: getLoading(state),
  isMobile: getIsMobile(state)
});

const mapCallbacksToProps = dispatch => ({
  clearFilters: (push, pathname) => {
    push({ pathname, search: '' });
    dispatch(clearFilters());
  },
  toggleShowMoreVisible: () => dispatch(toggleShowMoreVisible()),
  changeSelectedMoreFilter: (value) => {
    dispatch(setLocationBreadcrumb([]));
    dispatch(setSelectedMoreFilter(value));
  },
  checkSubmit: (evt, push, { pathname, qs }, keywords) => {
    evt.preventDefault();
    const newUrl = updateUrl(qs, keywords);
    if (typeof window !== 'undefined' && window.location.search === newUrl) return;
    push({
      pathname,
      search: newUrl
    });
  },
  changeQuickFilterValue: (value, { facets, keywords, base: { pathname, qs }, push }) => {
    const decodedValue = decodeURIComponent((value) ? 'quick-apply' : false );
    const encKey = encodeURIComponent('applicationType');
    let newUri = updateUrl(qs, keywords);
    const newUriPart = `${encKey}=${encodeURIComponent(decodedValue.split(':').pop())}`;
    let newLocation = '';
    if (value) {
      facets.applicationType.forEach( parent => {
        newUri = removeUrlPart(newUri, `${encKey}=${encodeURIComponent(parent.value)}`);
      });
      newLocation = (newUri.indexOf('?') > -1
        ? newUri.concat(`&${newUriPart}`)
        : newUri.concat(`?${newUriPart}`));
    }
    if (!value) {
      newLocation = clearAllFromUrl(newUri, 'applicationType');
    }
    push({
      pathname,
      search: newLocation,
      state: {
        notScroll: true
      }
    });
  },
  changeCheckBoxFilterValue: (checked, { facets, keywords, base: { pathname, qs }, push, key, value }) => {
    let newUri = updateUrl(qs, keywords);
    const encodedValue = encodeURIComponent(value);
    let newLocation = '';
    if (checked) {
      facets[key].forEach( parent => {
        newUri = removeUrlPart(newUri, `${key}=${encodeURIComponent(parent.value)}`);
      });
      newLocation = (newUri.indexOf('?') > -1
        ? newUri.concat(`&${key}=${encodedValue}`)
        : newUri.concat(`?${key}=${encodedValue}`));
    }
    if (!checked) {
      newLocation = clearTagFromUrl(newUri, {name: key, value});
    }
    push({
      pathname,
      search: newLocation,
      state: {
        notScroll: true
      }
    });
  }
});

const TopFiltersContainer = connect(mapStateToProps, mapCallbacksToProps)(TopFilters);

export default TopFiltersContainer;

